<template>
  <div>
    <goodsorder-list v-show="tabType === 1" @handleShow="handleShow" />
    <goodsorder-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"  />
  </div>
</template>
<script>

import goodsorderList from './list.vue'
import goodsorderShow from './show.vue'
export default {
  components: { goodsorderList, goodsorderShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    };
  },
  created() {},
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    },
  },
};
</script>
<style>
.filter-container .el-input__inner {
  /* width: 200px !important; */
}
</style>
